exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1_WClWPbku-6pH8WMwMYdY {\n  max-width: 90vw;\n  width: 1366px;\n  margin: 2rem auto 4rem;\n  min-height: 75vh;\n  display: grid;\n  justify-content: center;\n  align-content: center;\n  text-align: center; }\n  ._1_WClWPbku-6pH8WMwMYdY h1 {\n    color: #0e79b2; }\n  ._1_WClWPbku-6pH8WMwMYdY hr {\n    width: 100%;\n    margin: 15px 0 50px 0;\n    border-top: 1px solid #0e79b2; }\n", ""]);

// Exports
exports.locals = {
	"container": "_1_WClWPbku-6pH8WMwMYdY"
};